<template>
    <q-icon
        v-if="show"
        name="autorenew"
        style="font-size: 2rem; font-weight: bold"
        class="animate-spin items-center icon"/>
    <!--<div v-if="show" class="absolute fit top">-->
        <!--<div class="absolute fit bgr"></div>-->

        <!--<div class="text-center fit">-->
            <!--<q-icon-->
                <!--name="autorenew"-->
                <!--style="font-size: 2rem; font-weight: bold"-->
                <!--class="animate-spin items-center icon"/>-->
        <!--</div>-->
    <!--</div>-->
</template>

<script>
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    export default {
        name: 'RefreshComponent',
        components: {QIcon},
        props: ['observe'],
        computed: {
            show () {
                if (this.observe) {
                    if (this.observedValue.endsWith('_done')) {
                        return false
                    } else if (this.observedValue.endsWith('_ongoing')) {
                        return true
                    } else if (this.observedValue.endsWith('_failed')) {
                        return true
                    }
                }

                return false
            },
            observedValue () {
                if (this.observe) {
                    return this.$store.state.RS[this.observe] || ''
                }
                return ''
            }
        },
    }
</script>

<style scoped lang="scss">
    /*.top {*/
        /*z-index: 100;*/
    /*}*/
    /*.bgr {*/
        /*opacity: 0.2;*/
        /*background: #000;*/
    /*}*/

    /*.icon {*/
        /*margin-top: 50%;*/
    /*}*/
</style>